import { Provider } from '@angular/core';

import { TASK_ACTION_HANDLERS } from '../contracts/task-action.contract';
import { TaskActionHandlerRegistry } from '../services/task-action-handler-registry.service';

import { CheckPlannedAppointmentActionHandler } from '../handlers/check-planned-appointment-action.handler';
import { HealthCheckInActionHandler } from '../handlers/health-check-in-action.handler';
import { ManualAppointmentCancellationActionHandler } from '../handlers/manual-appointment-cancellation-action.handler';
import { OrphanedOfferingActionHandler } from '../handlers/orphaned-offering-action.handler';
import { ProcessGuaranteeApplicationActionHandler } from '../handlers/process-guarantee-application-action.handler';
import { ServiceRequestActionHandler } from '../handlers/service-request-action.handler';

export function provideTaskActionHandlers(): Provider[] {
  return [
    TaskActionHandlerRegistry,
    { provide: TASK_ACTION_HANDLERS, useClass: ProcessGuaranteeApplicationActionHandler, multi: true },
    { provide: TASK_ACTION_HANDLERS, useClass: ServiceRequestActionHandler, multi: true },
    { provide: TASK_ACTION_HANDLERS, useClass: ManualAppointmentCancellationActionHandler, multi: true },
    { provide: TASK_ACTION_HANDLERS, useClass: CheckPlannedAppointmentActionHandler, multi: true },
    { provide: TASK_ACTION_HANDLERS, useClass: OrphanedOfferingActionHandler, multi: true },
    { provide: TASK_ACTION_HANDLERS, useClass: HealthCheckInActionHandler, multi: true },
  ];
}
